import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5592 2.04346C19.2496 2.04346 19.8092 2.6031 19.8092 3.29346V6.92236C19.8092 7.56871 19.3165 8.10846 18.6728 8.16719L14.9586 8.5061C14.2711 8.56883 13.6629 8.06236 13.6002 7.37486C13.5374 6.68736 14.0439 6.07917 14.7314 6.01644L15.5182 5.94465C12.8383 4.38527 9.34495 4.75345 7.04922 7.04919C4.31497 9.78343 4.31497 14.2165 7.04922 16.9508C9.78346 19.685 14.2165 19.685 16.9508 16.9508C18.3181 15.5834 19.0015 13.7937 19.0015 12C19.0015 11.3096 19.5611 10.75 20.2515 10.75C20.9418 10.75 21.5015 11.3096 21.5015 12C21.5015 14.4297 20.5736 16.8635 18.7185 18.7185C15.008 22.4291 8.992 22.4291 5.28145 18.7185C1.5709 15.008 1.5709 8.99197 5.28145 5.28142C8.55208 2.01079 13.6139 1.62302 17.3092 4.11812V3.29346C17.3092 2.6031 17.8689 2.04346 18.5592 2.04346Z"
        fill={colorValue}
      />
    </svg>
  );
};
